import React from 'react';
import { Link } from 'react-router-dom';
import JournalDetailsCard from '../Components/JournalDetailsCard';
import QuickLinksCard from '../Components/QuickLinksCard';
import '../CSS/Home.css';

/* ── Trimmed Current Issue summary (replaces full <CurrentIssue /> embed) ── */
const CurrentIssueSummary = () => (
    <section className="home-section home-current-summary">
        <h2 className="home-section__title">Current Issue</h2>
        <p className="home-current-summary__vol">Volume 2, Issue 1</p>
        <h3 className="home-current-summary__theme">
            Artificial Intelligence and Digital Governance
        </h3>
        <p className="home-current-summary__blurb">
            Integrating AI with governance frameworks to build transparent, secure,
            ethical, and inclusive digital ecosystems for future-ready public
            administration and citizen-centric services.
        </p>

        <div className="home-current-summary__dates">
            <h4 className="home-current-summary__dates-title">Important Dates</h4>
            <ul className="home-current-summary__dates-list">
                <li><strong>Abstract Submission:</strong> 7 September 2026</li>
                <li><strong>Notification of Abstract Acceptance:</strong> 1 October 2026</li>
                <li><strong>Full Paper Submission:</strong> 18 October 2026</li>
                <li><strong>Paper Acceptance:</strong> 16 November 2026</li>
            </ul>
        </div>

    </section>
);

/* ── Home page ── */
const Home = () => {
    return (
        <div className="home-wrapper">
            <div className="home-layout">

                {/* ══ LEFT: main content ══ */}
                <main className="home-main">

                    {/* Hero */}
                    <section className="home-hero">
                        <h1 className="home-hero__title">
                            Innovative Trends in Multidisciplinary Engineering
                        </h1>
                        <p className="home-hero__desc">
                            <strong>ITME</strong> is a double-blind, peer-reviewed international
                            journal published biannually (July &amp; December) by K.R. Mangalam
                            University, Gurugram. The journal provides a high-quality platform for
                            interdisciplinary research in engineering and applied sciences, with
                            emphasis on innovative approaches, emerging technologies, and advanced
                            materials.
                        </p>
                        <p className="home-hero__desc">
                            We are committed to the highest standards of academic publishing through
                            a rigorous peer-review process and rapid, ethical review timelines.
                        </p>

                        <div className="home-hero__ctas">
                            <Link to="/form"     className="btn-primary-flat">Submit Research</Link>
                            <Link to="/archives" className="btn-outline-flat">Browse Issues</Link>
                        </div>
                    </section>

                    {/* Current Issue summary */}
                    <CurrentIssueSummary />

                    {/* Call for Papers */}
                    <section className="home-section home-cfp">
                        <h2 className="home-section__title">Call for Papers</h2>
                        <picture>
                            <source
                                type="image/webp"
                                srcSet="/cfp-480.webp 480w, /cfp-800.webp 800w, /cfp-1131.webp 1131w"
                                sizes="(max-width: 992px) 100vw, 60vw"
                            />
                            <img
                                src="/cfp-800.jpeg"
                                srcSet="/cfp-480.jpeg 480w, /cfp-800.jpeg 800w, /cfp-1131.jpeg 1131w"
                                sizes="(max-width: 992px) 100vw, 60vw"
                                alt="ITME Call for Papers"
                                className="home-cfp__img"
                                width="1131"
                                height="1600"
                                loading="lazy"
                                decoding="async"
                                onError={(e) => { e.currentTarget.style.display = 'none'; }}
                            />
                        </picture>
                        <a
                            href="/ITME_Call_for_Papers.pdf"
                            className="btn-outline-flat home-cfp__btn"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            📄 Download CFP (PDF)
                        </a>
                    </section>

                </main>

                {/* ══ RIGHT: sticky sidebar ══ */}
                <aside className="home-sidebar">
                    <JournalDetailsCard />
                    <QuickLinksCard />
                </aside>

            </div>
        </div>
    );
};

export default Home;